module.exports = "/assets/7854f9efc6eaeff5ffb13539c2212b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/3X.png
// module id = 1024
// module chunks = 0